module.exports = __webpack_public_path__ + "static/media/car.0481a11b.svg";